<template>
  <div class="help-page">
    <detail
      v-if="articleDetail.artical_image && articleDetail.artical_image.length > 0"
      :list="articleDetail.artical_image"
      :show-mark="processStatus === 1"
      type="fraction"
      class="detail-content"
    ></detail>
    <van-popup v-model="loginShow" class="x-van-popup">
      <xes-tal-login
        :loginData="loginData"
        @loginSuccess="loginSuccess"
        @regSuccess="regSuccess"
        @close="loginShow = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Detail from '../components/detail'
import { XesTalLogin } from '@xes/terra'
import { isApp } from '@utils/index'
import { getUrlParmas } from '@/common/utils/xesFunction'
export default {
  name: 'HelpPage',
  components: {
    Detail,
    'xes-tal-login': XesTalLogin
  },
  data() {
    return {
      articleDetail: [],
      processStatus: 1,
      isSelf: true,
      loginShow: false,
      urlParams: {},
      articleId: '',
      loginData: {
        sGroupId: this.$config.sGroupId,
        source_id: ''
      } // 登录所需参数
    }
  },
  created() {
    this.loginData.source_id = window._wltfChannel.hotUrlParams.source || ''
    this.urlParams = getUrlParmas(window.location.href) || {}
    this.articleId = this.urlParams.articleId
    this.checkLogin()
    this.getArticleDetail()
  },
  methods: {
    // 新用户注册成功
    regSuccess() {
      this.loginShow = false
      this.isLogin = true
      this.toHelp()
      this.$xesLogger.clickMsg({
        params: {
          clickid: 1.2,
          clicklevel: 1,
          action: 'regSucess',
          clickname: '网校新用户注册成功数'
        }
      })
    },
    // 老用户登录成功
    loginSuccess() {
      this.loginShow = false
      this.isLogin = true
      this.toHelp()
      this.$xesLogger.clickMsg({
        params: {
          clickid: 1.1,
          clicklevel: 1,
          action: 'loginSucess',
          clickname: '网校老用户登录成功数'
        }
      })
    },
    // 检测登录态
    async checkLogin() {
      await this.$api.checkLogin().then(res => {
        this.isLogin = res.code !== 11025
      })
    },
    // 唤起登陆
    toLogin() {
      if (isApp) {
        xesApp.appLoginBack = result => {
          if (Number(result) === 1) {
            const isAndroid =
              navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
            if (isAndroid) {
              window.location.reload()
            }
          }
        }
        xesApp.xesLogin('xesApp.appLoginBack')
      } else {
        this.loginShow = true
      }
    },
    // 获取文章详情
    async getArticleDetail() {
      const that = this
      console.log('getArticleDetail')
      const res = await that.$api.getArticleDetail({ artical_id: that.articleId })
      if (res.code === 0) {
        that.articleDetail = res.data
        that.processStatus = Number(that.articleDetail.process_status)
        that.isSelf = that.articleDetail.is_self
      } else {
        that.$toast(res.msg || '获取文章详情失败')
      }
    },
    // 参加夏令营
    jump() {
      this.$xesLogger.clickMsg({
        params: { clickid: '55.0.0', elemname: '参加夏令营' }
      })
      window.location.href = `https://activity.xueersi.com/advance/summerCampLottery/${location.search}#/`
    },
    // 点赞
    async toHelp() {
      console.log('toHelp')
      const that = this
      if (!that.isLogin) {
        that.toLogin()
        return
      }
      if (that.articleDetail.thumb_status) return
      this.$xesLogger.clickMsg({
        params: { clickid: '54.0.0', elemname: '为TA助力' }
      })
      const res = await that.$api.thumb({
        artical_id: Number(that.articleId)
      })
      if (res.code === 0) {
        await that.getArticleDetail()
        that.articleDetail.thumb_status = true
        that.$xesAlert({
          hasCloseBtn: true,
          type: 'alert',
          title: '点赞成功',
          message: '谢你的助力！赠送你<br/>精品写作定制课，快去领取吧～',
          sureText: '去领取',
          cancelText: '取消',
          onSure: () => {
            // 确认无误，确认提交
            // 跳转课程链接
            this.$xesLogger.clickMsg({
              params: { clickid: '55.1.0', elemname: '参加夏令营-去看看' }
            })
            window.location.href = res.data.course_link
            console.log('确认')
          }
        })
      } else {
        that.$toast(res.msg || '点赞请求错误')
      }
    }
  }
}
</script>
